import { defineStore } from 'pinia'

type siteParems = {
  [key: string]: any
}
export const useSiteInfoStore = defineStore('site', {
  state: () => ({
    data: {} as siteParems
  }),
  getters: {
    getSiteInfo: (state) => state.data
  },
  actions: {
    setSiteInfo(params: siteParems) {
      this.data = params
    }
  },
  persist: {
    storage: localStorage
  }
})
